<template>
    <el-card v-loading="loading">
      <div slot="header" class="clearfix" id="detail-status">
        <el-row :gutter="5">
          <el-col :lg="8">
            Situação Objetos Não Entregues
          </el-col>
        </el-row>
      </div>
      <PostSroMainHomeNotDeliveredStatus v-if="show" :tableData="tableStatus"/>
      <el-table v-else :data="tableData" stripe ref="tableData" size="mini" style="width: 100%">
        <el-table-column prop="status" :label="$t('status')" sortable center>
          <template slot-scope="scope">
            <el-tag type="success">{{ scope.row.description }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable prop="quantity" :label="$t('quantidade')" width="140"></el-table-column>
        <el-table-column prop="percentage" label="%">
          <template slot-scope="scope">
            <el-progress :stroke-width="20" :show-text="false" :percentage="scope.row.percentage"></el-progress>
          </template>
        </el-table-column>
        <el-table-column prop="late" label="#">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row.status)" type="text">Detalhes</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="show" @click="show = false" type="info">Voltar</el-button>

    </el-card>
</template>
<script>
import { SroService } from "@/services/customers/sro.services";
import PostSroMainHomeNotDeliveredStatus from './PostSroMainHomeNotDeliveredStatus';
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: 'PostSroMainHomeNotDelivered',
  props: ["startedAt", "finishedAt", "customer", "status", "services"],
  components: {
    PostSroMainHomeNotDeliveredStatus,
  },
  created() {
    this.$bus.$on("fetch", this.fetch);
  },
  beforeDestroy() {
    this.$bus.$off("fetch", this.fetch);
  },
  data() {
    return {
      show: false,
      loading: false,
      tableData: [],
      tableStatus: [],
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    detail(status) {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      SroService.notdeliveredstatus({
        customer: vm.customer,
        services: vm.services,
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD"),
        status,
      })
        .then((response) => {
          vm.tableStatus = response;
          document.getElementById("detail-status").scrollIntoView();
          vm.show = true;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    fetch() {
      const vm = this;
      vm.loading = true;
        const s = moment(vm.startedAt);
        const f = moment(vm.finishedAt);

        SroService.notdelivered({
          customer: vm.customer,
          services: vm.services,
          startedAt: s.format("YYYY-MM-DD"),
          finishedAt: f.format("YYYY-MM-DD"),
        })
          .then((response) => {
            console.log("delivered", response)
            vm.tableData = response;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
    },
  }
}
</script>
